// 批次 20（R20-1）：main-main（/main 一般首頁）的角色分流 body。
//
// 鏡像 MainController.java:78-79（@RequestMapping）＋:81-93 showMain → getMainPageByRoleAndJobType（:143-163）：
//   - UGY_西醫分支（getWesternMedicineUGYView :167-186）：isUgyStudent→/main/studentMain（:169/:172-173）、
//     isDepartmentAdmin→**/main/deptAdminMain**（:171/:174-175）、isUgyTeacher→/main/teacherMain（:170/:176-177）、
//     else→/main/main（:178-180）
//   - raw-dom 證據：admin/home/main-main.html（DeptAdmin 帳號捕獲）＝deptAdminMain.jsp 渲染結果
//     （menuRow 待填表單盒＋訓練計畫盒，:1247-1265；breadcrumb 科部管理員首頁，:1239）
//   - React Session 三角色映射：admin→DeptAdminBody（isDepartmentAdmin）、teacher→DashboardBody
//     （main-teacher-main 變體）、student→DashboardBody（main-student-main 變體）；伺服器端渲染
//     語意（URL 不變、渲染別頁 JSP）以 DashboardBody 的 variantPageId 鏡像（ui-id 保持 main-main 前綴）
//   - else 分支（/main/main＝main.jsp 一般首頁 tab 頁，535 行）在 React 三角色模型不可達
//     → KNOWN-NOT-DONE D20-2；dentisit/ma 家族帳號經 /main 的家族分流（getDentisitView/
//     getMedicalAffairsView）鏡像 UGY 分支（React Session 無 jobType 欄位）→ KNOWN-NOT-DONE D20-3
//
// 【證據等級】§7 第 3 級（原始碼＋raw-dom）。

import type { ReactElement } from 'react';
import { useSession } from '@/mocks/provider';
import { DashboardBody } from './DashboardBody';
import { DeptAdminBody } from '../deptAdmin/DeptAdminBody';

export function AdminMainBody({ pageId }: { pageId: string }): ReactElement {
  const { session } = useSession();
  if (session.role === 'admin') {
    // isDepartmentAdmin（MainController.java:171/:174-175）→ deptAdminMain.jsp 渲染。
    return <DeptAdminBody pageId={pageId} />;
  }
  // isUgyTeacher（:170/:176-177）→ teacherMain.jsp；isUgyStudent（:169/:172-173）→ studentMain.jsp。
  return <DashboardBody pageId={pageId} variantPageId={session.role === 'teacher' || session.role === 'mentor' ? 'main-teacher-main' : 'main-student-main'} />;
}
